import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteSpeedDialMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteSpeedDialMutation = { __typename?: 'Mutation', deleteSpeedDial?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string } | null> | null };

export type SaveSpeedDialMutationVariables = Types.Exact<{
  speedDialInput: Types.SpeedDialInput;
}>;


export type SaveSpeedDialMutation = { __typename?: 'Mutation', saveSpeedDial?: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };

export type SpeedDialShortNumbersQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
  speedDialId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type SpeedDialShortNumbersQuery = { __typename?: 'Query', speedDialShortNumbers: Array<string> };


export const DeleteSpeedDialDocument = gql`
    mutation DeleteSpeedDial($id: Int!) {
  deleteSpeedDial(id: $id) {
    location
    context
    type
  }
}
    `;
export type DeleteSpeedDialMutationFn = Apollo.MutationFunction<DeleteSpeedDialMutation, DeleteSpeedDialMutationVariables>;

/**
 * __useDeleteSpeedDialMutation__
 *
 * To run a mutation, you first call `useDeleteSpeedDialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpeedDialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpeedDialMutation, { data, loading, error }] = useDeleteSpeedDialMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSpeedDialMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSpeedDialMutation, DeleteSpeedDialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSpeedDialMutation, DeleteSpeedDialMutationVariables>(DeleteSpeedDialDocument, options);
      }
export type DeleteSpeedDialMutationHookResult = ReturnType<typeof useDeleteSpeedDialMutation>;
export type DeleteSpeedDialMutationResult = Apollo.MutationResult<DeleteSpeedDialMutation>;
export type DeleteSpeedDialMutationOptions = Apollo.BaseMutationOptions<DeleteSpeedDialMutation, DeleteSpeedDialMutationVariables>;
export const SaveSpeedDialDocument = gql`
    mutation SaveSpeedDial($speedDialInput: SpeedDialInput!) {
  saveSpeedDial(speedDialInput: $speedDialInput) {
    id
    errors {
      location
      context
      type
    }
  }
}
    `;
export type SaveSpeedDialMutationFn = Apollo.MutationFunction<SaveSpeedDialMutation, SaveSpeedDialMutationVariables>;

/**
 * __useSaveSpeedDialMutation__
 *
 * To run a mutation, you first call `useSaveSpeedDialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSpeedDialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSpeedDialMutation, { data, loading, error }] = useSaveSpeedDialMutation({
 *   variables: {
 *      speedDialInput: // value for 'speedDialInput'
 *   },
 * });
 */
export function useSaveSpeedDialMutation(baseOptions?: Apollo.MutationHookOptions<SaveSpeedDialMutation, SaveSpeedDialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSpeedDialMutation, SaveSpeedDialMutationVariables>(SaveSpeedDialDocument, options);
      }
export type SaveSpeedDialMutationHookResult = ReturnType<typeof useSaveSpeedDialMutation>;
export type SaveSpeedDialMutationResult = Apollo.MutationResult<SaveSpeedDialMutation>;
export type SaveSpeedDialMutationOptions = Apollo.BaseMutationOptions<SaveSpeedDialMutation, SaveSpeedDialMutationVariables>;
export const SpeedDialShortNumbersDocument = gql`
    query SpeedDialShortNumbers($userId: Int!, $speedDialId: Int) {
  speedDialShortNumbers(userId: $userId, speedDialId: $speedDialId)
}
    `;

/**
 * __useSpeedDialShortNumbersQuery__
 *
 * To run a query within a React component, call `useSpeedDialShortNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpeedDialShortNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpeedDialShortNumbersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      speedDialId: // value for 'speedDialId'
 *   },
 * });
 */
export function useSpeedDialShortNumbersQuery(baseOptions: Apollo.QueryHookOptions<SpeedDialShortNumbersQuery, SpeedDialShortNumbersQueryVariables> & ({ variables: SpeedDialShortNumbersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpeedDialShortNumbersQuery, SpeedDialShortNumbersQueryVariables>(SpeedDialShortNumbersDocument, options);
      }
export function useSpeedDialShortNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpeedDialShortNumbersQuery, SpeedDialShortNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpeedDialShortNumbersQuery, SpeedDialShortNumbersQueryVariables>(SpeedDialShortNumbersDocument, options);
        }
export function useSpeedDialShortNumbersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SpeedDialShortNumbersQuery, SpeedDialShortNumbersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpeedDialShortNumbersQuery, SpeedDialShortNumbersQueryVariables>(SpeedDialShortNumbersDocument, options);
        }
export type SpeedDialShortNumbersQueryHookResult = ReturnType<typeof useSpeedDialShortNumbersQuery>;
export type SpeedDialShortNumbersLazyQueryHookResult = ReturnType<typeof useSpeedDialShortNumbersLazyQuery>;
export type SpeedDialShortNumbersSuspenseQueryHookResult = ReturnType<typeof useSpeedDialShortNumbersSuspenseQuery>;
export type SpeedDialShortNumbersQueryResult = Apollo.QueryResult<SpeedDialShortNumbersQuery, SpeedDialShortNumbersQueryVariables>;